import { useQuery } from '@tanstack/react-query';
import { QueryKeys } from '../constants/query_keys';
import { apiV1 } from '../lib/api';
import { FIVE_MINUTES_IN_MS } from '../lib/time';

export const useWaterbodyTopSpecies = (params: {
  selectedSeasonGroupName: string;
  waterbodyUrlSlug: string;
}) => {
  const { selectedSeasonGroupName, waterbodyUrlSlug } = params;
  const waterbodyTopSpeciesQueryParams: Parameters<typeof apiV1.waterbodyTopSpeciesFetch>[1] = {
    season_group: selectedSeasonGroupName,
  };
  const waterbodyTopSpeciesQuery = useQuery({
    queryKey: QueryKeys.WATERBODIES.TOP_SPECIES(waterbodyUrlSlug, waterbodyTopSpeciesQueryParams),
    queryFn: async () => {
      const res = await apiV1.waterbodyTopSpeciesFetch(
        waterbodyUrlSlug,
        waterbodyTopSpeciesQueryParams
      );
      return res.data.data;
    },
    staleTime: FIVE_MINUTES_IN_MS,
    enabled: waterbodyUrlSlug != null,
  });

  const { data: waterbodyTopSpecies } = waterbodyTopSpeciesQuery;

  return { waterbodyTopSpecies };
};
